import type { Article } from '@/types';

export const articles: Article[] = [
  {
    slug: 'rise-of-ai-agents-2026',
    title: 'The Rise of AI Agents: How Autonomous Systems Are Reshaping Enterprise Workflows in 2026',
    excerpt: 'From customer service to supply chain management, AI agents are no longer experimental — they are becoming the backbone of modern enterprise operations, driving efficiency gains that were unimaginable just two years ago.',
    content: '',
    category: 'technology',
    author: 'Sarah Chen',
    authorAvatar: 'SC',
    date: 'July 5, 2026',
    readTime: '8 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20neural%20network%20visualization%20with%20glowing%20interconnected%20nodes%20on%20a%20deep%20dark%20green%20background%2C%20futuristic%20technology%20concept%20with%20subtle%20gradients%20and%20minimalist%20aesthetic%2C%20clean%20composition%20with%20plenty%20of%20negative%20space%2C%20editorial%20quality%20with%20soft%20ambient%20lighting&width=1600&height=900&seq=article-hero-01&orientation=landscape',
    imageSeq: 'article-hero-01',
    featured: true,
    trending: true,
  },
  {
    slug: 'quantum-computing-breakthrough',
    title: 'Quantum Computing Milestone: First Error-Corrected Logical Qubit Runs for 48 Hours Straight',
    excerpt: 'Researchers at a leading quantum lab have demonstrated sustained error correction that could finally make practical quantum computing a reality within this decade.',
    content: '',
    category: 'technology',
    author: 'Marcus Webb',
    authorAvatar: 'MW',
    date: 'July 3, 2026',
    readTime: '6 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20quantum%20particles%20floating%20in%20a%20dark%20space%20with%20teal%20and%20emerald%20energy%20waves%2C%20scientific%20visualization%20style%20with%20clean%20minimalist%20aesthetic%2C%20deep%20green%20tones%20with%20bright%20accent%20highlights%2C%20editorial%20photography%20quality&width=1600&height=900&seq=article-hero-02&orientation=landscape',
    imageSeq: 'article-hero-02',
    featured: true,
    trending: false,
  },
  {
    slug: 'startup-valuation-reset',
    title: 'The Great Valuation Reset: Why Smart Founders Are Embracing Down Rounds in 2026',
    excerpt: 'After years of inflated expectations, a new wave of pragmatic founders is choosing sustainable growth over vanity metrics, and investors are rewarding them for it.',
    content: '',
    category: 'business',
    author: 'Priya Kapoor',
    authorAvatar: 'PK',
    date: 'July 4, 2026',
    readTime: '7 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20space%20with%20warm%20amber%20lighting%20and%20green%20plants%2C%20abstract%20financial%20charts%20projected%20on%20a%20frosted%20glass%20wall%2C%20clean%20aesthetic%20with%20soft%20shadows%2C%20editorial%20photography%20style%20with%20muted%20tones&width=1600&height=900&seq=article-hero-03&orientation=landscape',
    imageSeq: 'article-hero-03',
    featured: true,
    trending: true,
  },
  {
    slug: 'neobrutalism-design-trend',
    title: 'Neo-Brutalism Is Dead: The Design Trends Actually Shaping Digital Products Right Now',
    excerpt: 'Forget raw aesthetics and harsh shadows — 2026 is all about warm minimalism, tactile interfaces, and designs that prioritize emotional connection over visual shock value.',
    content: '',
    category: 'design',
    author: 'Yuki Tanaka',
    authorAvatar: 'YT',
    date: 'July 2, 2026',
    readTime: '5 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20interior%20design%20with%20terracotta%20and%20cream%20tones%2C%20curved%20furniture%20silhouettes%2C%20soft%20natural%20lighting%20streaming%20through%20large%20windows%2C%20clean%20aesthetic%20composition%2C%20editorial%20photography%20with%20gentle%20shadows&width=1600&height=900&seq=article-hero-04&orientation=landscape',
    imageSeq: 'article-hero-04',
    featured: false,
    trending: true,
  },
  {
    slug: 'remote-work-evolution',
    title: 'Beyond Hybrid: The Async-First Movement Reshaping How Global Teams Collaborate',
    excerpt: 'The most successful distributed companies are abandoning synchronous standups and embracing documentation-driven workflows that make time zones irrelevant.',
    content: '',
    category: 'business',
    author: 'James Okonkwo',
    authorAvatar: 'JO',
    date: 'June 30, 2026',
    readTime: '6 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20lit%20home%20workspace%20with%20laptop%20on%20a%20wooden%20desk%2C%20green%20plants%20and%20coffee%20cup%2C%20sunlight%20filtering%20through%20sheer%20curtains%2C%20cozy%20minimalist%20aesthetic%2C%20editorial%20photography%20with%20soft%20ambient%20light&width=1600&height=900&seq=article-hero-05&orientation=landscape',
    imageSeq: 'article-hero-05',
    featured: false,
    trending: true,
  },
  {
    slug: 'ocean-carbon-capture',
    title: 'Ocean Forests: How Kelp Restoration Projects Are Becoming the Unsung Heroes of Carbon Capture',
    excerpt: 'Marine biologists and climate entrepreneurs are joining forces on massive kelp reforestation projects that could sequester carbon 20 times faster than land forests.',
    content: '',
    category: 'science',
    author: 'Dr. Amina Hassani',
    authorAvatar: 'AH',
    date: 'June 28, 2026',
    readTime: '9 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sunlight%20piercing%20through%20a%20dense%20underwater%20kelp%20forest%2C%20emerald%20green%20and%20teal%20water%20tones%2C%20schools%20of%20small%20fish%20visible%2C%20ethereal%20atmospheric%20light%20rays%2C%20nature%20documentary%20photography%20style&width=1600&height=900&seq=article-hero-06&orientation=landscape',
    imageSeq: 'article-hero-06',
    featured: false,
    trending: false,
  },
  {
    slug: 'creator-economy-matures',
    title: 'The Creator Economy Grows Up: From Viral Chasing to Sustainable Media Empires',
    excerpt: 'Top creators are building diversified revenue streams, hiring editorial teams, and transforming personal brands into full-fledged media companies with real staying power.',
    content: '',
    category: 'culture',
    author: 'Lena Vogel',
    authorAvatar: 'LV',
    date: 'June 25, 2026',
    readTime: '7 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20creative%20studio%20with%20warm%20lighting%2C%20camera%20equipment%20and%20editing%20setup%20on%20a%20wooden%20table%2C%20mood%20board%20on%20the%20wall%2C%20cozy%20and%20professional%20atmosphere%2C%20editorial%20photography%20with%20soft%20amber%20tones&width=1600&height=900&seq=article-hero-07&orientation=landscape',
    imageSeq: 'article-hero-07',
    featured: false,
    trending: false,
  },
  {
    slug: 'biomaterials-revolution',
    title: 'Growing Buildings: The Mycelium-Based Materials That Could Replace Concrete by 2035',
    excerpt: 'Architects and material scientists are cultivating mushroom-based structural materials that are fire-resistant, carbon-negative, and strong enough for multi-story construction.',
    content: '',
    category: 'science',
    author: 'Carlos Mendez',
    authorAvatar: 'CM',
    date: 'June 22, 2026',
    readTime: '8 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organic%20mycelium%20texture%20closeup%20with%20warm%20earthy%20tones%2C%20natural%20fiber%20patterns%2C%20soft%20diffused%20lighting%2C%20sustainable%20material%20aesthetic%2C%20minimalist%20scientific%20photography%20style%20with%20cream%20and%20brown%20palette&width=1600&height=900&seq=article-hero-08&orientation=landscape',
    imageSeq: 'article-hero-08',
    featured: false,
    trending: false,
  },
  {
    slug: 'ai-art-copyright',
    title: 'Who Owns an AI Painting? The Copyright Battle That Could Redefine Creative Ownership',
    excerpt: 'As AI-generated art floods galleries and marketplaces, courts around the world are grappling with questions that challenge the very foundation of intellectual property law.',
    content: '',
    category: 'opinion',
    author: 'Rachel Kim',
    authorAvatar: 'RK',
    date: 'June 20, 2026',
    readTime: '10 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20art%20with%20flowing%20organic%20shapes%20in%20warm%20coral%20and%20cream%20tones%2C%20paintbrush%20and%20digital%20tablet%20side%20by%20side%2C%20creative%20studio%20atmosphere%2C%20editorial%20photography%20with%20soft%20natural%20light&width=1600&height=900&seq=article-hero-09&orientation=landscape',
    imageSeq: 'article-hero-09',
    featured: false,
    trending: false,
  },
  {
    slug: 'typography-renaissance',
    title: 'The Typography Renaissance: Why Variable Fonts Are Finally Having Their Moment',
    excerpt: 'After years of slow adoption, variable fonts are transforming web performance and creative expression — and the tools have finally caught up with the vision.',
    content: '',
    category: 'design',
    author: 'Yuki Tanaka',
    authorAvatar: 'YT',
    date: 'June 18, 2026',
    readTime: '5 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20typography%20letterpress%20blocks%20arranged%20artistically%20on%20a%20cream%20paper%20background%2C%20warm%20natural%20lighting%2C%20vintage%20printing%20aesthetic%20with%20modern%20minimalist%20composition%2C%20editorial%20photography%20style&width=1600&height=900&seq=article-hero-10&orientation=landscape',
    imageSeq: 'article-hero-10',
    featured: false,
    trending: false,
  },
  {
    slug: 'food-tech-fermentation',
    title: 'Precision Fermentation Goes Mainstream: The Lab-Grown Proteins Hitting Grocery Shelves This Year',
    excerpt: 'From animal-free dairy to cultivated meat, precision fermentation technology is scaling rapidly, promising a future where sustainability and taste no longer have to compromise.',
    content: '',
    category: 'science',
    author: 'Dr. Amina Hassani',
    authorAvatar: 'AH',
    date: 'June 15, 2026',
    readTime: '7 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Laboratory%20glassware%20with%20golden%20amber%20liquid%20on%20a%20clean%20white%20surface%2C%20warm%20backlighting%2C%20minimalist%20scientific%20aesthetic%2C%20soft%20shadows%2C%20editorial%20food%20science%20photography&width=1600&height=900&seq=article-hero-11&orientation=landscape',
    imageSeq: 'article-hero-11',
    featured: false,
    trending: false,
  },
  {
    slug: 'slow-living-movement',
    title: 'The Slow Living Manifesto: Why High Achievers Are Choosing to Do Less in 2026',
    excerpt: 'A growing movement of former hustle-culture advocates is embracing deliberate slowness — and finding that doing less is actually the ultimate productivity hack.',
    content: '',
    category: 'culture',
    author: 'Lena Vogel',
    authorAvatar: 'LV',
    date: 'June 12, 2026',
    readTime: '6 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20a%20comfortable%20armchair%20by%20a%20large%20window%2C%20warm%20sunlight%2C%20stack%20of%20books%20and%20a%20ceramic%20mug%2C%20peaceful%20minimalist%20interior%2C%20editorial%20lifestyle%20photography&width=1600&height=900&seq=article-hero-12&orientation=landscape',
    imageSeq: 'article-hero-12',
    featured: false,
    trending: false,
  },
];

export const featuredArticles = articles.filter(a => a.featured);
export const trendingArticles = articles.filter(a => a.trending);

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter(a => a.category === slug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find(a => a.slug === slug);
}